import { render, staticRenderFns } from "./driver-list.vue?vue&type=template&id=dd5445a6"
import script from "./driver-list.vue?vue&type=script&lang=js"
export * from "./driver-list.vue?vue&type=script&lang=js"
import style0 from "./driver-list.vue?vue&type=style&index=0&id=dd5445a6&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports